var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.10657 5.55395C3.27195 5.22693 3.61204 5 4 5H20C20.388 5 20.7281 5.22694 20.8934 5.55398L12 11.7794L3.10657 5.55395ZM1.00004 5.9852C0.99992 5.99354 0.999908 6.00188 1 6.01022V18C1 19.6523 2.34772 21 4 21H20C21.6523 21 23 19.6523 23 18V6.01402C23.0002 6.00256 23.0002 5.99109 22.9999 5.97962C22.9889 4.33665 21.6455 3 20 3H4C2.35265 3 1.00805 4.33968 1.00004 5.9852ZM21 7.9207V18C21 18.5477 20.5477 19 20 19H4C3.45228 19 3 18.5477 3 18V7.92066L11.4266 13.8193C11.7709 14.0603 12.2292 14.0603 12.5735 13.8193L21 7.9207Z",
    fill: "#0173C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallMailIcon);
export default __webpack_public_path__ + "static/media/SmallMailIcon.53c82401.svg";
export { ForwardRef as ReactComponent };